<section id="sign-up" class="sec_sign_up">
  <div class="content-container">
    <h3 [hidden]="signUpFormHeader">Sign up for the latest updates on <b>Factor XIIa</b></h3>
    <div class="sign_up_form" [hidden]="signUpForm">
      <form [formGroup]="signupForm" (ngSubmit)="signup()">
        <div>
          <label>
            First Name
          </label>
          <input name="FirstName" tabindex="0" formControlName="FirstName">
          <div *ngIf="signupForm.controls['FirstName'].invalid && (signupForm.controls['FirstName'].dirty ||  signupForm.controls['FirstName'].touched) " class="alert alert-danger">
            Please enter your first name.
          </div>  
        </div>
        <div>
          <label>
            Last Name
          </label>
          <input formControlName="LastName" tabindex="0" name="LastName">
          <div *ngIf="signupForm.controls['LastName'].invalid && (signupForm.controls['LastName'].dirty || signupForm.controls['LastName'].touched)" class="alert alert-danger">
            Please enter your last name.
          </div> 
        </div>
        <div>
          <label>
            Email
          </label>
          <input formControlName="Email" tabindex="0" name="Email">
          <div *ngIf="signupForm.controls['Email'].invalid && (signupForm.controls['Email'].dirty || signupForm.controls['Email'].touched)" class="alert alert-danger">
            Please enter a valid email address.
        </div> 
          </div>
        <div class="zipcode">
          <label>
            ZIP Code
          </label>
          <input formControlName="Zip" tabindex="0" name="Zip">
          <div *ngIf="signupForm.controls['Zip'].invalid && (signupForm.controls['Zip'].dirty || signupForm.controls['Zip'].touched)" class="alert alert-danger">
            Please enter a valid 5-digit ZIP Code.
          </div> 
        </div>
        <div class="age">
          <input type="checkbox" tabindex="0" formControlName="AgeConsent" name="AgeConsent" class="Years" (change)="checkSelection($event)">
          <label>
            I am 18 years of age or older
          </label>
        </div>
        <div *ngIf="signupForm.controls['AgeConsent'].invalid && (signupForm.controls['AgeConsent'].dirty || signupForm.controls['AgeConsent'].touched)" class="alert alert-danger checkboxalert">
          If you are 18 or older, select the checkbox to continue. This program is only for individuals 18 or older.
        </div>
        <div class="form_label">I am a:</div>
        <div class="i_am pure-g">
          <label class="pure-u-4-24">
            <input type="radio" value="Patient" name="InquirerType" tabindex="0" formControlName="InquirerType"><p>Patient</p>
          </label>
          <label class="pure-u-4-24" >
            <input type="radio" value="Caregiver" name="InquirerType" tabindex="0" formControlName="InquirerType"><p>Caregiver</p>
          </label>
          
        </div>
        <div *ngIf="signupForm.controls['InquirerType'].invalid && (signupForm.controls['InquirerType'].dirty || signupForm.controls['InquirerType'].touched)" class="alert alert-danger radioerror1">
          Please select a response.
        </div> 
        <div class="form_label">What type of treatment are you or your loved one taking for HAE?</div>
        <div class="treatment pure-g">
          <label class="pure-u-8-24">
            <input type="radio" value="Preventive" name="TreatmentType" formControlName="TreatmentType" tabindex="0"><p>Preventive treatment</p>
          </label>
          <label class="pure-u-8-24">
            <input type="radio" value="On-Demand" name="TreatmentType" formControlName="TreatmentType" tabindex="0"><p>On-demand treatment</p>
          </label>
          <label class="pure-u-8-24">
            <input type="radio" value="Not-taking" name="TreatmentType" formControlName="TreatmentType" tabindex="0"><p>I’m/they’re not taking medicine for HAE</p>
          </label>          
        </div>
        <div *ngIf="signupForm.controls['TreatmentType'].invalid && (signupForm.controls['TreatmentType'].dirty || signupForm.controls['TreatmentType'].touched)" class="alert alert-danger radioerror2">
          Please select a response.
      </div> 
        <div class="instruction">
          <p>By submitting this form, you are consenting to disclose any information provided, including your name, email address, address, telephone number, and any other information (collectively “Personal Information”) to CSL Behring and its representatives, agents, and contractors, including CSL Behring’s support program(s) (collectively “CSL Behring Entities”) and to receive communications with relevant information from CSL Behring Entities. You may also receive relevant information and advertisements, including marketing information, from CSL Behring Entities by mail, email, and/or telephone in the future to provide information or to offer enrollment in educational programs and programs intended to benefit patients using or eligible to use CSL Behring therapies. You will have the ability to opt out from receiving communications from CSL Behring Entities at any time. CSL Behring and CSL Entities will not sell your personal information.</p>
          <p>CSL Behring respects your privacy. For an explanation of how CSL Behring will use the information you are submitting, please view our <a href="https://www.csl.com/privacy-policy" target="_blank">Privacy Policy</a></p>
        </div>
        <button type="submit" [disabled]="this.disableButton" tabindex="0"><p>SIGN UP</p> <img target="_blank" src="../../../assets/img/sign_up_icon.svg" alt="Sign up icon" title="Sign up icon" /></button>
      </form>
    </div>
    <div class="thank_you_box" [hidden]="thankYouDiv">
      <p>Thank you for signing up</p>
      <p>You will receive information from CSL Behring shortly.</p>
    </div>
  </div>
</section>